import ReactNativeBlobUtil from 'react-native-blob-util'
import moment from 'moment'
import { HealthDataReport } from '@src/types'

export interface DownloadReportPdfResult {
  success: true
  filePath: string
}

export interface DownloadReportPdfError {
  success: false
  error: string
}

export type DownloadReportPdfResponse = DownloadReportPdfResult | DownloadReportPdfError

const buildFileName = (report: HealthDataReport): string => {
  const kind = report.kind.toLowerCase()
  const startDate = moment(report.startDate).format('YYYY-MM-DD')
  const endDate = moment(report.endDate).format('YYYY-MM-DD')
  return `${kind}_report_${startDate}_${endDate}.pdf`
}

export const downloadReportPdf = async (
  report: HealthDataReport,
  pdfUrl: string,
): Promise<DownloadReportPdfResponse> => {
  const dirs = ReactNativeBlobUtil.fs.dirs
  const fileName = buildFileName(report)
  const filePath = `${dirs.CacheDir}/${fileName}`

  try {
    const response = await ReactNativeBlobUtil.config({
      path: filePath,
    }).fetch('GET', pdfUrl)

    const status = response.info().status

    if (status >= 200 && status < 300) {
      return { success: true, filePath: response.path() }
    }

    await cleanupPdfFile(filePath)
    return { success: false, error: `Failed to download PDF (status: ${status})` }
  } catch (error) {
    await cleanupPdfFile(filePath)
    return {
      success: false,
      error: error instanceof Error ? error.message : 'Unknown error occurred',
    }
  }
}

export const cleanupPdfFile = async (filePath: string): Promise<void> => {
  try {
    await ReactNativeBlobUtil.fs.unlink(filePath)
  } catch {
    // Ignore cleanup errors
  }
}
